/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import React, { useState } from "react";
import { t } from "i18n";

import Inspector from "components/inspector/inspector";
import Form, { FormConfig } from "pages/manage/custom-fields/form";
import { AllowedFieldTypes, AllowedFieldSubTypes, AllowedValueTypes, UnsavedCustomField } from "api/custom-field";

interface OwnProps {
  active: boolean;
  saveCustomMetadataField: (customField: UnsavedCustomField) => void;
  cancelSave: () => void;
}

type Props = OwnProps;

const CustomMetadataInspector: React.SFC<Props> = ({ active, saveCustomMetadataField, cancelSave }) => {
  const initialCustomField: UnsavedCustomField = {
    name: "",
    "field-type": AllowedFieldTypes.METADATA,
    "field-sub-type": AllowedFieldSubTypes.STORY,
    "is-mandatory": false,
    "value-type": AllowedValueTypes.DESCRIPTION,
    config: null
  };

  const [customField, setCustomField] = useState(initialCustomField);

  const customFieldFormConfig: FormConfig = {
    customField,
    allowedDataTypes: [{ displayName: "Text Area", type: AllowedValueTypes.DESCRIPTION }]
  };

  const onChangeHandler = (partialCustomField: Partial<UnsavedCustomField>) =>
    setCustomField({ ...customField, ...partialCustomField });

  return (
    <Inspector
      title={t("custom-metadata.inspector.create-title")}
      onClose={() => {
        setCustomField(initialCustomField);
        cancelSave();
      }}
      isActive={active}
      actionButtonLabel={t("custom-metadata.inspector.save-button-label")}
      isActionButtonDisabled={!customField.name}
      onActionButtonClick={() => {
        saveCustomMetadataField(customField);
      }}>
      <Form config={customFieldFormConfig} onChange={onChangeHandler} />
    </Inspector>
  );
};

export default CustomMetadataInspector;
